<template>
    <div class="main">
        <a-card :bordered="false" class="index-top-tj">
            <a-card-grid style="width:14%;text-align:center">
                <router-link to="/searvistor">
                <img src="../../../static/svg/menu1.svg" alt="">
                <span>快商宝</span> 
                </router-link>
            </a-card-grid>
            <a-card-grid style="width:14%;text-align:center" >
                <router-link to="/visitor">
                <img src="../../../static/svg/menu2.svg" alt="">
                <span>精准获客</span> 
                </router-link>
            </a-card-grid>
            <a-card-grid style="width:14%;text-align:center">
                <router-link to="/clue">
                <img src="../../../static/svg/menu3.svg" alt="">
                <span>线索</span> 
                </router-link>
            </a-card-grid>
            <a-card-grid style="width:14%;text-align:center">
                <router-link to="/custom">
                <img src="../../../static/svg/menu4.png" alt="">
                <span>客户</span> 
                </router-link>
            </a-card-grid>
            <a-card-grid style="width:14%;text-align:center">
                <router-link to="/business">
                <img src="../../../static/svg/menu5.svg" alt="">
                <span>商机</span> 
                </router-link>
            </a-card-grid>
            <a-card-grid style="width:14%;text-align:center">
                <router-link to="/report">
                <img src="../../../static/svg/menu6.svg" alt="">
                <span>仪表盘</span> 
                </router-link>
            </a-card-grid>
            <!-- <a-card-grid style="width:14%;text-align:center">
                <router-link to="/">
                <img src="../../../static/svg/menu7.svg" alt="">
                <span>目标</span> 
                </router-link>
            </a-card-grid> -->
        </a-card>

        <a-card title="销售简报" class="index-jb">
            <a slot="extra" href="#">more</a>
            <a-row type="flex" justify="space-between">
                <a-col :span="11" class="menu-border">
                    <h2>新增</h2>
                    <a-row>
                        <a-col :span="6">
                            <strong>{{saledata.newdata}}</strong>
                            <p>线索数</p>
                        </a-col>
                        <a-col :span="6">
                            <strong>{{saledata.newkehu}}</strong>
                            <p>客户数</p>
                        </a-col>
                        <a-col :span="6">
                            <strong>{{saledata.newcontract}}</strong>
                            <p>联系人数</p>
                        </a-col>
                        <a-col :span="6">
                            <strong>{{saledata.newbussness}}</strong>
                            <p>商机数</p>
                        </a-col>
                    </a-row>     
                </a-col>
                <a-col :span="5" class="menu-border">
                    <h2>成交</h2>
                    <a-row>
                        <a-col :span="12">
                            <strong>{{saledata.win}}</strong>
                            <p>赢单数量</p>
                        </a-col>
                        <a-col :span="12">
                            <strong>{{saledata.winmoney}}</strong>
                            <p>赢单金额(元)</p>
                        </a-col>
                    </a-row>     
                </a-col>
                <a-col :span="6">
                    <h2>跟进次数</h2>
                    <a-row>
                        <a-col :span="12">
                            <strong>{{saledata.follownum}}</strong>
                            <p>写跟进</p>
                        </a-col>
                        <a-col :span="12">
                            <strong>{{saledata.callnum}}</strong>
                            <p>打电话</p>
                        </a-col>
                        <!-- <a-col :span="8">
                            <strong>0</strong>
                            <p>签到</p>
                        </a-col> -->
                    </a-row>     
                </a-col>
            </a-row>
        </a-card>

        <div class="index-charts">
            <div class="card">
                <a-card  title="待办客资">
                    <div class="guest-statis">
                        <div class="guest-list">
                            <router-link to="/home/message">
                                <span>待跟进客户</span>
                                <span>{{dbdata.tofollowkehu}}</span>
                            </router-link>
                        </div>
                         <div class="guest-list">
                            <router-link to="/home/message">
                                <span>待跟进线索</span>
                                <span>{{dbdata.tofollowdata}}</span>
                            </router-link>
                        </div>
                         <div class="guest-list">
                            <router-link to="/home/message">
                                <span>三天内预计成交商机</span>
                                <span>{{dbdata.todealbussness}}</span>
                            </router-link>
                        </div>
                         <div class="guest-list">
                            <router-link to="/home/message">
                                <span>即将掉保的线索</span>
                                <span>{{dbdata.willoutdata}}</span>
                            </router-link>
                        </div>
                         <div class="guest-list">
                            <router-link to="/home/message">
                                <span>即将掉保的客户</span>
                                <span>{{dbdata.willoutkehu}}</span>
                            </router-link>
                        </div>
                    </div>
                </a-card>
            </div>
            <div class="card">
                <a-card  title="销售漏斗">
                    <div  slot="extra">
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="time" @click="showdate">
                                <a-tooltip slot="suffix" @click="showdate">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="dateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdate(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-range-picker format="YYYY-MM-DD" @change="dateChange"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                    <div id="weightChart" style="width: 100%;height:410px;"></div>
                </a-card>
            </div>
            <!-- <div class="card">
                <a-card  title="目标">
                    <div slot="extra">
                        <a-input placeholder="请选择时间" autocomplete="off" disabled/>
                    </div>
                    <div class="index-target">
                        <div id="targetChart" style="width: 257px;height:300px;"></div>
                    </div>
                </a-card>
            </div> -->
        </div>

    </div>
</template>

<script>
// import {sendMsg} from '../../../static/js/wbsocket.js'
import MessageSvg from '../../../static/svg/1.svg'; // path to your '*.svg' file.
import echarts from "echarts";
// 引入饼状图组件
require('echarts/lib/chart/pie')
import Vue from 'vue'
Vue.prototype.$echarts = echarts
export default {
    data(){
        return{
            lddata:"",
            dbdata:"",
            saledata:"",

            time:"今天",
            dateshow:false,
            currentdate:"",
            datelist:['今天','昨天','本周','上周','本月','上月'],
        }
    },
    components:{
        MessageSvg
    },
    mounted(){
        this.ldtj()
        // 代办客资
        this.$axios.get('/api/todocapital',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }  
        }).then((res)=>{
             if(res.data.code==200){
                this.dbdata=res.data.data
             }else{
                this.$message.error(res.data.msg);
             }
        })

        // 销售简报
        this.$axios.get('/api/singlesale',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }  
        }).then((res)=>{
             if(res.data.code==200){
                this.saledata=res.data.data
             }else{
                this.$message.error(res.data.msg);
             }
        })


        var targetChart = this.$echarts.init(document.getElementById("targetChart"))
        targetChart.setOption= ({
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 10,
                data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
            },
            series: [
                {
                    name: '访问来源',
                    type: 'pie',
                    radius: ['50%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        {value: 335, name: '直接访问'},
                        {value: 310, name: '邮件营销'},
                        {value: 234, name: '联盟广告'},
                        {value: 135, name: '视频广告'},
                        {value: 1548, name: '搜索引擎'}
                    ]
                }
            ]
        });

         this.$axios.get('/api/salefunnel',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.time
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.lddata=res.data.data
                    this.drawLine()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
      
        
    },
    methods:{
        showdate(){
            this.dateshow=!this.dateshow
        },
        ldtj(){
              // 销售漏斗
            this.$axios.get('/api/salefunnel',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.time
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.lddata=res.data.data
                    this.drawLine()
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },
         // 跟进日期筛选
        selectdate(a,b){
            this.currentdate=a
            this.time=b
            this.dateshow=false
            this.ldtj()
      
        },
        dateChange(data,dateString){
            console.log(dateString)
            this.time=dateString[0]+'~'+dateString[1]
            this.dateshow=false
            this.ldtj()
        
        },
        drawLine(){

            // 销售漏斗
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
            weightChart.setOption({
                color: ['#6688f9','#6688f9','#6688f9','#6688f9','#5fcaca','#c6cde5' ],

                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c}%"
                },
    
                series: [
                    {
                        name:'漏斗图',
                        type:'funnel',
                        left: '5%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '10%',
                        maxSize: '90%',
                        sort: 'descending',
                        gap: 2,
                       
                        emphasis: {
                            label: {
                                fontSize: 14,
                            }
                        },
                        data: [
                            {value: 90, name: '初步接洽',barHeight: 6},
                            {value: 75, name: '需求确定'},
                            {value: 60, name: '方案/报价'},
                            {value: 45, name: '谈判审核'},
                            {value: 30, name: '赢单'},
                            {value: 15, name: '输单'},
                        ]
                    },

                    {
                        name:'漏斗图',
                        type:'funnel',
                        left: '5%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '10%',
                        maxSize: '90%',
                        label: {
                            position: 'inside',
                            formatter: '￥{b}',
                            color: '#fff',
                            show: true,
                        },
                        itemStyle: {
                            opacity: 0.5,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        emphasis: {
                            label: {
                                position: 'inside',
                                formatter: '￥{b}' ,
                            }
                        },
                        data: [

                            {value: 90, name: this.lddata.first,barHeight: 6},
                            {value: 75, name: this.lddata.needs},
                            {value: 60, name: this.lddata.plans},
                            {value: 45, name: this.lddata.negotiate},
                            {value: 30, name: this.lddata.win},
                            {value: 15, name: this.lddata.lose},
                        ],
                        // Ensure outer shape will not be over inner shape when hover.
                        z: 100
                    }
                ]
            });
        }
    }

}


</script>
<style>
.logo {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}
</style>





// WEBPACK FOOTER //
// src/components/main/index.vue